import React from 'react';
import { Link } from 'react-router-dom';
import I18n from '../../config/i18n';
import { Grid, Row, Col } from '../../utils/grid/Grid';

import './not-found.css';

const NotFound = () => (
  <div className="not-found-wrapper">
    <Grid>
      <Row middle="xs" center="xs" className="not-found">
        <Col xs>
          <h2 className="not-found-title">{I18n.t('not_found.title')}</h2>
          <p className="not-found-description">{I18n.t('not_found.description')}</p>
          <a href={`tel:${I18n.t('not_found.number')}`} className="not-found-number">
            {I18n.t('not_found.number')}
          </a>
          <Link to={`/${I18n.locale}`} reloadDocument className="not-found-button">
            {I18n.t('not_found.back_to_homepage')}
          </Link>
        </Col>
      </Row>
    </Grid>
  </div>
);

export default NotFound;
